import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { UnidataTable } from '~/components';

import {
  recordFiltering,
} from '~/store/modules/operacaoradprefaturabloqueioplacarelatorio/actions';


function OperacaoRadPreFaturaBloqueioPlacaRelatorioLista() {

  const buttons = [];

  const operacaoradprefaturabloqueioplacarelatorio = useSelector(
    (state) => state.operacaoradprefaturabloqueioplacarelatorio
  );

  const status = useMemo(() => [
    { value: 'Aguardando Aprovação Gestor do Órgão', label: '1' },
    { value: 'Aguardando Emissão', label: '0' },
    { value: 'Aguardando Emissão da Fatura', label: '5' },
    { value: 'Aguardando Emissão Pedido de Faturamento', label: '4' },
    { value: 'Cancelada por Contestação', label: '8' },
    { value: 'Contestação do Gestor do Órgão', label: '2' },
    { value: 'Contestação respondida pela Abastek', label: '3' },
    { value: 'Fatura enviada para Órgão', label: '6' },
    { value: 'Fatura Paga', label: '7' },
    { value: 'Vencida', label: '100' },
  ], []);


  const header = useMemo(() => [
    {
      id: 'orga_nome',
      label: 'Nome do Órgão',
      align: 'left',
    },
    {
      id: 'orga_sigla',
      label: 'Órgão Sigla',
      filter: {
        type: 'text',
      },
      align: 'left',
    },

    {
      id: 'fatu_codigo',
      label: 'Pré-fatura',
      filter: {
        type: 'text',
      },
      align: 'left',
    },

    {
      id: 'fatu_periodo_str',
      label: 'Período',
      filter: {
        type: 'text',
      },
      align: 'center',
    },

    {
      id: 'veic_placa',
      label: 'Placa',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'apbf_observacao',
      label: 'Observação',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'veic_codigo_pleito',
      label: 'Pleito',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'apbf_login_executante',
      label: 'Login Bloqueio',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'veic_data_bloqueio_faturamento_str',
      label: 'Data Bloqueio Veículo',
      align: 'center',
      formatted: (value) => (value !== '' ? value : '-'),
    },
    {
      id: 'fatu_status_str',
      label: 'Status',
      align: 'center',
      converter: status,
      filter: {
        type: 'select',
        options: status,
      },
    },
  ], []);

  const filter = useMemo(() => [
    {
      id: 'orga_codigo',
      label: 'Órgão',
      type: 'autocomplete',
      autocomplete: {
        url: 'orgaos',
        label: 'orga_nome',
        unique: 'orga_codigo',
        params: {
          fieldlist: 'orga_codigo, orga_nome',
        }
      }
    }
  ], []);

  return (
    <>
      <UnidataTable
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        redux={operacaoradprefaturabloqueioplacarelatorio}
        read={recordFiltering}
        actions={buttons}
        detach="fatu_codigo"
        custom={filter}
      />
    </>
  );
}

export default OperacaoRadPreFaturaBloqueioPlacaRelatorioLista;
